<template>
  <div id="goFinance">
    <el-button
      id="vueStepGoFinanceBtn"
      type="primary"
      class="goFinanceBtn"
      @click="$store.commit('process/vueStep1/setDrawerGoFinance',true)"
      round
    >财务/行政</el-button>
    <el-drawer
      title
      :visible.sync="$store.state.process.vueStep1.drawerGoFinance"
      :direction="'rtl'"
      :before-close="handleClose"
    >
      <div>
        <div class="selectionsBody">
          <el-card shadow="hover" class="goFinanceCard">
            <h4 @click="goFinanceClick('报销')">报销</h4>
          </el-card>
          <el-card shadow="hover" v-for="item in finnanceList" :key="item.id" class="goFinanceCard">
            <h4 :id="item.itemId" @click="goFinanceClick(item.name)">{{item.name}}</h4>
          </el-card>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  data() {
    return {
      member_id: '',
      company_id: '',
      token: '',
      details_project_id: '',
      finnanceList: [
        // {
        //   id: '12',
        //   itemId: '',
        //   name: '项目结算',
        // },
        // {
        //   id: '2',
        //   itemId: '',
        //   name: '业务结算',
        // },
        {
          id: '3',
          itemId: '',
          name: '项目专家费',
        },
        {
          id: '4',
          itemId: '',
          name: '到账记录',
        },
        // {
        //   id: '11',
        //   itemId: '',
        //   name: '合同登记',
        // },
        {
          id: '5',
          itemId: '',
          name: '邮寄',
        },
        {
          id: '6',
          itemId: '',
          name: '报告用章',
        },
        {
          id: '7',
          itemId: '',
          name: '其他用章',
        },
        {
          id: '8',
          itemId: '',
          name: '合同用章',
        },
        {
          id: '9',
          itemId: '',
          name: '合同存档',
        },
        {
          id: '10',
          itemId: '',
          name: '外部用章',
        },
      ],
    }
  },
  components: {},
  watch: {},
  props: ['projectId'],
  async mounted() {},
  methods: {
    goFinanceClick(val) {
      // this.drawerGoFinance = false
      this.$store.commit('process/vueStep1/setDrawerGoFinance', false)
      if (
        val == '邮寄' ||
        val == '报告用章' ||
        val == '其他用章' ||
        val == '合同用章' ||
        val == '外部用章' ||
        val == '合同存档'
      ) {
        this.$router.push({
          path: '/adminTop',
          query: {
            project_id: this.projectId,
            isFromProjectDrawer: '1',
            fromDrawType: val,
          },
        })
      } else {
        this.$router.push({
          path: '/financeTop',
          query: {
            project_id: this.projectId,
            isFromProjectDrawer: '1',
            fromDrawType: val,
          },
        })
      }
    },
    handleClose() {
      // this.drawerGoFinance = false
      this.$store.commit('process/vueStep1/setDrawerGoFinance', false)
    },
  },

  created: function () {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.details_project_id = this.$route.query.project_id || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
  },
}
</script>
<style lang="less" scoped>
#goFinance {
  display: flex;
  align-items: center;
  .goFinanceBtn {
    position: absolute;
    top: 50px;
    right: 20px;
    padding: 12px 20px;
  }
}
#goFinance {
  font-size: 14px;
  /deep/.el-drawer__body {
    padding: 0 25px;
    .selectionsBody {
      height: calc(100vh - 45px - 32px - 40px);
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .el-card__body {
    }
  }
}
.stepChangeBox {
  padding-top: 30px;
}
#goFinance .filter-item-name {
  margin-right: 15px;
  text-align: right;
}
#goFinance .filter-item-wrapper {
  display: flex;
  align-items: center;
}
#goFinance .filter-dash-btn {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  // width: 234px;
  width: 100%;
  height: 40px;
  // border-radius: 4px;
  border: 1px solid #c9ccd8;
  color: #c9ccd8;
  cursor: pointer;
  transition: all 0.3s;
}
#goFinance .filter-item-wrapper .filter-dash-btn:hover {
  border: 1px dashed #107fff;
}
#goFinance .filter-tips-default {
  display: flex;
  justify-content: flex-start;
  box-sizing: border-box;
  padding-left: 15px;
  align-items: center;
  width: 100%;
  height: 32px;
  transition: all 0.3s;
}
#goFinance .filter-item-wrapper .filter-dash-btn:hover .filter-tips-default {
  color: #107fff;
}
.filter-checked-app {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  width: 100%;
  padding: 4px;
}
.checked-app-item {
  padding: 2px 6px;
  margin: 0 4px 0 0;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
}
.checked-clear {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #ccc;
  transition: color 0.2s;
}
.checked-clear:hover {
  color: #aaa;
}

// 修改弹窗样式
// dialog弹窗
/deep/.el-dialog {
  border-radius: 10px;
  .el-dialog__header {
    border-radius: 10px 10px 0 0;
    background-color: #f4f5f6;
    font-size: 20px;
    color: #333;
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 40px;
  }
}
/deep/ .el-dialog__header {
  padding: 16px 24px;
  color: #304265;
  background: #fff;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 4px 4px 0 0;
  .el-dialog__title {
    margin: 0;
    color: #304265;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
  }
}
/deep/.el-dialog__body {
  padding: 0;
  font-size: 14px;
  line-height: 1.5;
  .container {
    width: 100%;
    display: flex;
    .left {
      width: 55%;
      border-right: 1px solid #e8e8e8;
      box-sizing: border-box;
      .leftHead {
        display: flex;
        align-items: center;
        padding: 12px 24px;
        border-bottom: 1px solid #e8e8e8;
        i {
          color: #aaa;
        }
        // (deep)
        .el-input__inner {
          height: 22px;
          border: none;
          padding-left: 10px;
        }
      }
      .leftBody {
        box-sizing: border-box;
        padding-left: 10px;
        padding-top: 10px;
        height: 344px;
        overflow-y: auto;
        overflow-x: hidden;
      }
    }
    .right {
      box-sizing: border-box;
      padding: 16px;
      width: 45%;
      height: 390px;
      overflow-x: hidden;
      overflow-y: scroll;
      .h3-organization-selected {
        position: relative;
        display: inline-block;
        background: #fafafa;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        padding: 0 24px 0 26px;
        margin: 0 8px 8px 0;
        height: 22px;
        max-width: 100%;
        .el-icon-user {
          left: 8px;
          margin-right: 6px;
          font-size: 12px;
          color: #bfbfbf;
          transform: translateY(-50%);
          position: absolute;
          top: 50%;
        }
        .el-icon-close {
          color: #bfbfbf;
          transform: translateY(-50%);
          position: absolute;
          top: 50%;
          width: 10px;
          height: 10px;
          font-size: 10px;
          margin-left: 8px;
          right: 8px;
        }
        .h3-organization-selected-name {
          display: inline-block;
          height: 100%;
          line-height: 1.5;
          max-width: 215px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.dialog-footer {
  width: 100%;
  display: flex;
  padding-left: 30%;
  .el-button {
    // width: 180px;
    width: 23%;
    height: 45px;
    padding: 0;
    font-size: 18px;
    font-weight: normal;
    color: #fff;
    border: none;
    border-radius: 25px;
    background-color: #40a0f2;
    margin-bottom: 10px;
  }
  .el-button:first-child {
    margin-right: 5%;
  }
}
// 修改弹窗样式
.configRow {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-around;
  .el-button {
    font-size: 16px;
    font-weight: normal;
    border: none;
    width: 150px;
    height: 40px;
    background: rgb(64, 160, 242);
    color: #fff;
    border-radius: 24px;
    padding: 0;
    margin-left: 30px;
  }
}
/deep/.el-drawer__header {
  margin-bottom: 16px;
}
.diaForm_box {
  width: 100%;
  padding-left: 50px;
  box-sizing: border-box;
  /deep/.el-form-item__content {
    line-height: 36px;
  }
  /deep/.el-form-item__label {
    line-height: 36px;
    font-size: 16px;
    color: #333;
  }
  /deep/.labelFormItem {
    /deep/.ProjectType {
      width: 80%;
      flex-wrap: wrap;
      height: initial;
      max-height: 105px;
      overflow-y: auto;
      /deep/.el-radio {
        // width: 30%;
        height: 35px;
      }
      /deep/.el-checkbox {
        width: 20%;
        .el-checkbox__label {
          font-size: 16px;
          font-weight: normal;
        }
      }
    }
  }
  .inputTwoRow {
    box-sizing: border-box;
    // padding: 0 16%;
    // padding-right: 14%;
    width: 100%;
    display: flex;
    /deep/.el-form-item:nth-child(2) {
      margin-left: 10%;
    }
    /deep/.el-input__inner {
      width: 100%;
    }
  }
  .diaFormTitle {
    width: 100%;
    font-weight: bold;
    color: #128bf1;
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .diaFormTitle::before {
    content: '';
    display: block;
    width: 3px;
    height: 16px;
    background-color: #40a0f2;
    margin-right: 5px;
  }
  .diaFormTitle1 {
    width: 100%;
    font-weight: bold;
    color: #128bf1;
    font-size: 18px;
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .diaFormTitle1 span {
    display: flex;
    align-items: center;
  }
  .diaFormTitle1 span::before {
    content: '';
    display: block;
    width: 3px;
    height: 16px;
    background-color: #40a0f2;
    margin-right: 5px;
  }
}
/deep/.stepDia {
  margin-top: 10vh;
}
.goFinanceCard {
  /deep/.el-card__body {
    padding: 0;
    h4 {
      padding: 12px 20px;
    }
  }
  cursor: pointer;
}
</style>